import { atom } from 'jotai';

import { availableAppointmentDatesAsyncAtom } from './availableAppointmentDatesAsyncAtom';
import { selectedAppointmentAsyncAtom } from './selectedAppointmentAsyncAtom';

export const availableAppointmentTimesAsyncAtom = atom(async (get) => {
  const selectedAppointment = await get(selectedAppointmentAsyncAtom);
  const availableAppointments = await get(availableAppointmentDatesAsyncAtom);

  return availableAppointments.find(
    (appointment) => appointment.date === selectedAppointment.date
  )?.availableTimes;
});
